import React, { useEffect, useState } from 'react';
import {
  SearchFacetsResponse,
  SearchFacetsResponseBuckets,
  SearchStateExtendsType,
  SearchStateFilterObj,
} from '../../organisms/SearchResults/store/store.type';
import { SearchFacetsList, SearchFacetsListCodes } from '../../organisms/SearchResults/index.constant';
import { StyledCheckboxItemDiv, StyledCheckboxItemsContainer } from '../../organisms/SearchResults/index.styles';
import { StyledActivitiesFilterDiv } from './index.styles';
import { CheckBox, checkboxVariation } from '@marriott/mi-ui-library';
import { useWindowSize } from '../../hooks';
import { useConditionalPageContextSERP } from '../../hooks';
import { formatNumberByLocale } from '../../utils';
import { useConditionalSessionUpdateContext } from '../../hooks';
import { BREAKPOINT_DESKTOP_1023, BREAKPOINT_TABLET } from '../../organisms/SearchResults/lib/application.constants';
import { useConditionalSearchFilterContextWithSerpFlag } from '../../hooks/lib/useConditionalSearchFilterContext';
declare module 'react' {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface HTMLAttributes<T> {
    custom_click_track_value?: string;
  }
}

export const ActivitiesFilterComponent: React.FC<{
  onItemSelect: (arg: SearchFacetsList, arg2: SearchStateFilterObj) => void;
  clearFilterState: SearchStateExtendsType | undefined | null;
  activities?: SearchFacetsResponse;
  itemList?: SearchFacetsResponse;
}> = ({ onItemSelect, clearFilterState, activities, itemList }) => {
  const { searchQueryState } = useConditionalSearchFilterContextWithSerpFlag();
  const { interactionsSelected, setInteractionsSelected } = useConditionalSessionUpdateContext();
  const clickTrackingLoc = 'Phoenix Search Results';
  const { currentLocale } = useConditionalPageContextSERP();

  const [currSelectedItem, setCurrSelectedItem] = useState<SearchStateFilterObj | undefined>(
    searchQueryState[SearchFacetsList.activities]
  );
  const { width } = useWindowSize();

  const getCurrenActivities = (): SearchFacetsResponse =>
    activities ??
    (itemList
      ? itemList
      : // eslint-disable-next-line @typescript-eslint/no-explicit-any
        searchQueryState?.filter?.filter((key: any) => key?.type?.code === SearchFacetsListCodes?.activities)[0]);

  const [allActivities, setAllActivites] = useState<SearchFacetsResponse | undefined>(getCurrenActivities());

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onSelectFilter = (event: any, data: SearchFacetsResponseBuckets): void => {
    if (event.key === 'Enter' || event.type === 'click' || event.type === 'change' || event.keyCode === 13) {
      let obj: SearchStateFilterObj | undefined = { ...currSelectedItem };
      if (obj !== undefined) {
        if (data.code in obj) {
          delete obj[data.code];
        } else {
          obj[data.code] = data.code;
        }
      } else {
        obj = {};
        obj[data.code] = data.code;
      }
      setCurrSelectedItem(obj);
      if (onItemSelect) {
        onItemSelect(SearchFacetsList.activities, obj);
      }
    }
    setInteractionsSelected({ ...interactionsSelected, activities: true });
  };

  useEffect(() => {
    setAllActivites(getCurrenActivities());
  }, [itemList]);

  useEffect(() => {
    if (clearFilterState === undefined || clearFilterState === null) {
      setCurrSelectedItem(undefined);
    }
  }, [clearFilterState]);

  return allActivities?.type.count ? (
    <StyledActivitiesFilterDiv className="t-font-alt-s hotel-types-filters-container">
      <fieldset>
        <div className="t-font-alt-s filter-heading-container">
          <legend>
            <h4
              className={
                (width && width > BREAKPOINT_DESKTOP_1023
                  ? `t-subtitle-l`
                  : width && width > BREAKPOINT_TABLET
                  ? `t-subtitle-l`
                  : `t-subtitle-m`) + ' filter-heading'
              }
            >
              {allActivities?.type?.label}
            </h4>
          </legend>
        </div>
        <StyledCheckboxItemsContainer>
          {allActivities?.buckets?.map((activityType: SearchFacetsResponseBuckets, idx: number) => (
            <StyledCheckboxItemDiv className="m-checkbox-selection-item hotel-type-description" key={idx}>
              <CheckBox
                variation={checkboxVariation.SIMPLE}
                className=""
                checkboxId={`activities-${activityType?.code}-checkbox`}
                checkboxName="activity_filter_checkbox"
                onChange={(e): void => onSelectFilter(e, activityType)}
                onKeyDown={(e): void => onSelectFilter(e, activityType)}
                checked={currSelectedItem ? activityType.code in currSelectedItem === true : false}
                inputClassName="checkbox-input custom_click_track"
                setTabIndex={-1}
                children={
                  <>
                    <span className="t-font-s">{activityType?.label}</span>
                    {activityType?.count && (
                      <span className="t-font-s pl-1">
                        ({formatNumberByLocale(activityType?.count, currentLocale)})
                      </span>
                    )}
                  </>
                }
                {...{
                  custom_click_track_value: `${clickTrackingLoc}| Activities options:${activityType?.label} |internal`,
                }}
              />
            </StyledCheckboxItemDiv>
          ))}
        </StyledCheckboxItemsContainer>
      </fieldset>
      <hr aria-hidden className="filter-separator" />
    </StyledActivitiesFilterDiv>
  ) : null;
};
